<template>
  <div class="jj_con">
    <div class="title_all">Introduction</div>
    <div v-html="body"></div>
    <span class="title_more">
      <router-link to="/FixedBody?ItemId=10">VIEW MORE +</router-link>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      body: '',
    }
  },
  mounted() {
    this.getBody()
  },
  methods: {
    getBody() {
      let params = [1100]
      this.$store
        .dispatch('_getHeader', params)
        .then((res) => {
          this.body = res.data.Data[0].Body
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>
